import { render, staticRenderFns } from "./updateBaseInfo.vue?vue&type=template&id=93e3e32a&scoped=true&"
import script from "./updateBaseInfo.vue?vue&type=script&lang=js&"
export * from "./updateBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "../../../../assets/styles/introduce-common.less?vue&type=style&index=0&id=93e3e32a&lang=less&scoped=true&"
import style1 from "./updateBaseInfo.vue?vue&type=style&index=1&id=93e3e32a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e3e32a",
  null
  
)

export default component.exports